import axios from "axios";
import { API } from "../context/AuthContext";

const sid = () => { let s = sessionStorage.getItem("rl_sid"); if (!s) { s = Math.random().toString(36).slice(2) + Date.now().toString(36); sessionStorage.setItem("rl_sid", s); } return s; };

export function trackFunnel(event, meta = {}) {
  try { axios.post(`${API}/analytics/track`, { event, path: window.location.pathname, sid: sid(), meta }).catch(() => {}); } catch {}
}
